import React from "react";
import useAuth  from "../../../hooks/useAuth";
import {APP_PERMISSION} from "@/constants/userConstants";

interface PermissionRenderingProps {
    children: React.ReactNode;
    permissions: APP_PERMISSION[];
}

const PermissionRendering: React.FC<PermissionRenderingProps> = ({ children, permissions }) => {
    const { checkUserPermissions } = useAuth();

    const hasPermissions = checkUserPermissions(permissions)

    if (!hasPermissions) return null;

    return <>{children}</>;
};

export default PermissionRendering;